import { Component, input, output } from '@angular/core';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import { BottomSheetComponent, type BottomSheetSettings } from '@hunting-nature/shared-ui/components/bottom-sheet/bottom-sheet.component';
import { ComingSoon } from '@hunting-nature/shared-ui/components/coming-soon-screen-component/coming-soon-screen.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-coming-soon-modal',
  imports: [TranslocoPipe, AppButtonComponent, BottomSheetComponent, ComingSoon],
  templateUrl: './coming-soon-modal.component.html',
  styleUrls: ['./coming-soon-modal.component.scss'],
})
export class ComingSoonModal {
  // inputs
  public readonly open = input.required<boolean>();
  public readonly useDarkMode = input<boolean>(true);

  // outputs
  public readonly closed = output<void>();
  public readonly dismissed = output<void>();

  protected offlineModeSheetSettings: BottomSheetSettings = {
    fitHeight: true,
  };

  protected handleSheetClosed(): void {
    this.closed.emit();
  }

  protected handleSheetDismissed(): void {
    this.dismissed.emit();
  }

  protected handleAgreeButton(): void {
    this.closed.emit();
  }
}
